import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import { useLocation, useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOutAlt,
  faTimes,
  faHome,
  faAddressBook,
  faFileInvoiceDollar,
  faMoneyCheck,
  faHospital,
  faBriefcase,
  faPlusCircle,
  faList,
  faPaperPlane,
  faHouseUser,
  faTruck,
  faArchive,
  faWarehouse,
  faArrowAltCircleDown,
  faExpandArrowsAlt,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Badge,
  Image,
  Button,
  Dropdown,
  Accordion,
  Navbar,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { PagesRoutes } from "../../../pages_routes";
import ThemesbergLogo from "../../../assets/easylab.svg";
import NavItem from "../../Utils/NavItem";
import { axiosInstance } from "../../../config/axios";
import { APIURL } from "../../../configApi";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
const LessSidebar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);

  const showClass = show ? "show" : "";
  const { user, expand } = props;

  const onCollapse = () => setShow(!show);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button
            as={Nav.Link}
            className="d-flex justify-content-between align-items-center"
          >
            <span>
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />{" "}
              </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">{children}</Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  return (
    <div className="less-sidebar">
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}
        >
          <div
            className="sidebar-inner px-2 pt-3"
            style={{ width: "100px !important" }}
          >
            <Nav
              className="flex-column pt-3 pt-md-0"
              style={{ width: "100px !important" }}
            >
              <div className="p-2 mb-4">
                <Image
                  src={ThemesbergLogo}
                  className="card-img-top border-white"
                />
              </div>

              <Button onClick={() => expand()} className="nav-link">
                <FontAwesomeIcon icon={faAngleDoubleRight} />
              </Button>
              {user?.role === "laboratory" ? (
                <>
                  <NavItem
                    className="nav-link"
                    title=""
                    link={PagesRoutes.LaboDashboard.path}
                    icon={faHome}
                  />
                  <NavItem
                    title=""
                    link="/laboratory/works"
                    icon={faBriefcase}
                  />

                  <CollapsableNavItem
                    eventKey="dentistes"
                    title=""
                    icon={faHouseUser}
                  >
                    <NavItem
                      title=""
                      eventkey="dentistes"
                      link={PagesRoutes.LaboDentists.path}
                      icon={faList}
                    />
                    <NavItem
                      title=""
                      eventkey="invitations"
                      link={PagesRoutes.LaboInvitations.path}
                      icon={faPaperPlane}
                    />
                  </CollapsableNavItem>

                  <CollapsableNavItem
                    eventKey="agents"
                    title=""
                    icon={faAddressBook}
                  >
                    <NavItem
                      title=""
                      eventkey="agents/add"
                      link={PagesRoutes.LaboAgentsAdd.path}
                      icon={faPlusCircle}
                    />
                    <NavItem
                      title=""
                      eventkey="agents"
                      link={PagesRoutes.LaboAgents.path}
                      icon={faList}
                    />
                  </CollapsableNavItem>

                  <CollapsableNavItem
                    eventKey="coursiers"
                    title=""
                    icon={faTruck}
                  >
                    <NavItem
                      title=""
                      eventkey="coursiers/add"
                      link={PagesRoutes.LaboCouriersAdd.path}
                      icon={faPlusCircle}
                    />
                    <NavItem
                      title=""
                      eventkey="coursiers"
                      link={PagesRoutes.LaboCouriers.path}
                      icon={faList}
                    />
                  </CollapsableNavItem>
                  <NavItem
                    title=""
                    link="/laboratory/stock"
                    icon={faWarehouse}
                  />
                  <NavItem
                    title=""
                    eventkey="paiements"
                    link={PagesRoutes.LaboPayments.path}
                    icon={faMoneyCheck}
                  />

                  <NavItem
                    title=""
                    eventkey="invoices"
                    link={PagesRoutes.LaboInvoices.path}
                    icon={faFileInvoiceDollar}
                  />
                  <NavItem
                    title=""
                    link={PagesRoutes.LaboArchives.path}
                    icon={faArchive}
                  />

                  {/*<NavItem title="Laboratoires" link="/laboratoires" icon={faHospital} />*/}
                </>
              ) : user?.role === "courier" ? (
                <>
                  <NavItem
                    title=""
                    link={PagesRoutes.CourierDashboard.path}
                    icon={faHome}
                  />
                  <NavItem
                    title=""
                    link={PagesRoutes.CourierWorks.path}
                    icon={faBriefcase}
                  />
                  <NavItem
                    title=""
                    link={PagesRoutes.CourierProfile.path}
                    icon={faFileInvoiceDollar}
                  />
                </>
              ) : user?.role === "dentist" ? (
                <>
                  <NavItem
                    title=""
                    link={PagesRoutes.DentistDashboard.path}
                    icon={faHome}
                  />
                  <NavItem
                    title=""
                    link={PagesRoutes.DentistWorks.path}
                    icon={faBriefcase}
                  />
                  <NavItem
                    title=""
                    link="/dentist/payments"
                    icon={faMoneyCheck}
                  />
                  <NavItem
                    title=""
                    link={PagesRoutes.DentistInvoices.path}
                    icon={faFileInvoiceDollar}
                  />

                  <CollapsableNavItem
                    eventKey="laboratories"
                    title=""
                    icon={faHouseUser}
                  >
                    <NavItem
                      title=""
                      link={PagesRoutes.DentistLaboratories.path}
                      icon={faList}
                    />
                    <NavItem
                      title=""
                      link={PagesRoutes.DentistInvitations.path}
                      icon={faPaperPlane}
                    />
                  </CollapsableNavItem>

                  <CollapsableNavItem
                    eventKey="assistants/"
                    title=""
                    icon={faAddressBook}
                  >
                    <NavItem
                      title=""
                      link={PagesRoutes.DentistAgentsAdd.path}
                      icon={faPlusCircle}
                    />
                    <NavItem
                      title=""
                      link={PagesRoutes.DentistAgents.path}
                      icon={faList}
                    />
                  </CollapsableNavItem>
                  <NavItem
                    title=""
                    link={PagesRoutes.DentsitArchives.path}
                    icon={faArchive}
                  />
                </>
              ) : (
                <>
                  <NavItem
                    className="nav-link"
                    title=""
                    link={PagesRoutes.AgentDashboard.path}
                    icon={faHome}
                  />
                  <NavItem
                    className="nav-link"
                    title=""
                    link={PagesRoutes.AgentWorks.path}
                    icon={faBriefcase}
                  />

                  <NavItem
                    title=""
                    eventkey="Dentistes"
                    link={PagesRoutes.AgentDentists.path}
                    icon={faHouseUser}
                  />

                  {/* <NavItem
                    title="agents"
                    eventkey="Agents"
                    link={PagesRoutes.AgentAgents.path}
                    icon={faAddressBook}
                  />

                  <NavItem
                    title="coursiers"
                    eventkey="coursiers"
                    link={PagesRoutes.AgentCouriers.path}
                    icon={faTruck}
                  /> */}

                  <NavItem
                    title=""
                    link={PagesRoutes.AgentArchives.path}
                    icon={faArchive}
                  />

                  {/*<NavItem title="Laboratoires" link="/laboratoires" icon={faHospital} />*/}
                </>
              )}

              <Dropdown.Divider className="my-3 border-indigo" />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </div>
  );
};
export default LessSidebar;
